import React from 'react'
import { createPortal } from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Tray } from '@mobi/component-library/Overlays/Tray'
import { Icon } from '@mobi/component-library/Common/V2'
import { colors } from '@mobi/component-library/Theme/Common'
import { setBonusDescriptionToDisplay } from '@core/Areas/AppHeader/Store'
import { getBonusDescriptionToDisplay } from '@core/Areas/AppHeader/Store/selectors'
import { TrayArticleStyled } from './common.styles'

export const BonusCashDescriptionTooltipTray: React.FC = () => {
  const dispatch = useDispatch()
  const showBonusDescription = useSelector(getBonusDescriptionToDisplay)

  return createPortal(
    <Tray
      isOpen={showBonusDescription === 'bonus_cash'}
      headerTitle='Bonus Cash'
      dismissStatus='allowed'
      onDismiss={() => dispatch(setBonusDescriptionToDisplay(undefined))}
      trayStyle={{ maxHeight: '82vh' }}
    >
      <TrayArticleStyled>
        <section>
          <Icon name='DuocolorCurrencyDollarCircle' color={colors.success[600]} size='5rem' />
        </section>

        <div />

        <p>
          When you’ve got <b>Bonus Cash</b>, TABtouch is giving you{' '}
          <b>the best bonus you’ll find anywhere</b>—you’re literally <b>betting on us</b>. Bonus
          Cash gives you extra chances to win without spending your own money, and the best part? If
          your bet wins, <b>we return your Bonus Cash stake along with your winnings</b>. It’s real
          value and a great way to boost your balance.
        </p>

        <p>
          When placing a <b>racing bet</b>, you’ll see the option to apply your Bonus Cash on
          Quickbet. You’re in control—you can choose to use all of your bonus or just a portion of
          it.
        </p>

        <p>
          For <b>sports bets</b>, it works slightly differently. If you have Bonus Cash available,
          we’ll automatically use it first when you place a sports bet. You don’t need to do a
          thing—just place your bet as usual, and we’ll handle the rest.
        </p>

        <p>
          Once your bet is settled, any winnings plus your Bonus Cash stake are paid straight into
          your cash balance, ready to use or withdraw. It’s a simple way to get more from your bets
          and enjoy a little extra value every time you play.
        </p>

        <p>
          Your Bonus Cash balance is <b>highlighted in green</b> and can be easily found in your{' '}
          <b>account menu</b>, where all the details are displayed.
        </p>
      </TrayArticleStyled>
    </Tray>,
    document.body
  )
}
